import Link from "@amzn/awsui-components-react/polaris/link";
import {
  FUNDING_BENEFITS_GUIDE_LINK,
  PARTNER_CENTRAL_MIGRATION_GUIDE,
  FUNDING_POLICY_LINK,
  PRM_REQUIREMENTS_LINK,
} from "shared/util/constants/constantValues";
import React from "react";

export const policyUpdatedBanner = (setNotificationsItems) => {
  return {
    type: "info",
    content: (
      <React.Fragment>
        Review the{" "}
        <Link href={FUNDING_BENEFITS_GUIDE_LINK} external>
          2026 Partner Funding Benefits Guide
        </Link>{" "}
        for important program updates and{" "}
        <Link href={PARTNER_CENTRAL_MIGRATION_GUIDE} external>
          Partner Central Migration Guide
        </Link>{" "}
        for new funding experience. By July 31, 2026, Partners must comply with
        the new{" "}
        <Link href={FUNDING_POLICY_LINK} external>
          Funding Policy
        </Link>{" "}
        and complete{" "}
        <Link href={PRM_REQUIREMENTS_LINK} external>
          Partner Revenue Measurement (PRM) requirements
        </Link>{" "}
        to maintain funding eligibility.
      </React.Fragment>
    ),
    dismissible: true,
    dismissLabel: "Dismiss message",
    onDismiss: () => setNotificationsItems([]),
    id: "policy_updated_banner",
  };
};
